import { render, staticRenderFns } from "./VOverlayPreloader.vue?vue&type=template&id=13230ae6&"
import script from "./VOverlayPreloader.vue?vue&type=script&lang=js&"
export * from "./VOverlayPreloader.vue?vue&type=script&lang=js&"
import style0 from "./VOverlayPreloader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports